<template>
    <div>
        <div class="box">
            <div class="chart" ref="student"></div>
            <div class="table">
                <div style="border-bottom: 1px solid #fff;">安全预警处理情况</div>
                <dv-scroll-board :config="config" style="width:100%;height:240px" />
            </div>
        </div>
    </div>
</template>

<script>
import { dataBoardWarn } from "@/api/index";
export default {
    data() {
        return {
            xdata: [],
            ydata: [],
            tableData: [],
            config: {
                data: [],
                waitTime: 4000,
                rowNum: 4,
                oddRowBGC: '',
                evenRowBGC: '',
            }
        }
    },
    created() {
        this.getList();
    },
    methods: {
        async getList() {
            const res = await this.axios.post(dataBoardWarn);
            if (res.data.code == 1) {
                this.tableData = res.data.data.warn.list;
                let arr = []
                this.tableData.forEach(e => {
                    arr.push([
                        `
                        <div class="left" style="width:30%;border-bottom: 1px solid #fff;">
                            <el-tag type="warning" effect="plain">${e.status == 1 ? "已处理" : "未处理"}</el-tag>
                            <div>${e.warn_date}</div>
                            <div>${e.warn_time}</div>
                        </div>
                        <div class="right" style="width:70%;border-bottom: 1px solid #fff;">
                            <div style="height:70%;white-space:normal;word-break:break-all;word-wrap:break-word;overflow: hidden">${e.remark}</div>
                            <div style="color:#354ccf;">【${e.status == 1 ? "相关人员已处理" : "待相关人员处理"}】</div>
                        </div>
                        `
                    ])
                })

                this.config.data = arr;
                this.config = { ...this.config }
                this.xdata = res.data.data.warn.week_count.axis_name;
                this.ydata = res.data.data.warn.week_count.axis_value;
                this.getStudent();
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },
        getStudent() {
            const chart = this.$refs.student;
            const myChart = this.$echarts.init(chart);
            const option = {
                legend: {},
                tooltip: {},
                title: {
                    text: '本周预警数',
                    subtext: '',
                    left: 'left',
                    textStyle: {
                        fontSize: '14',
                        color: '#fff',
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.xdata,
                    axisLine: {
                        lineStyle: {
                            color: "#fff"
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    show: false,
                },
                series: [
                    {
                        data: this.ydata,
                        type: 'line',
                        areaStyle: {}
                    }
                ]
            }
            myChart.setOption(option)
            window.addEventListener("resize", function () {
                myChart.resize()
            })
            this.$on('hook:destroyed', () => {
                window.removeEventListener("resize", function () {
                    myChart.resize();
                });
            })
        }
    },
}
</script>

<style lang='scss' scoped>
.box {
    width: 100%;
    height: 100%;
    .chart {
        width: 100%;
        height: 100px;
    }
    .table {
        width: 100%;
        height: 60%;
        color: #fff;
        /deep/ .row-item {
            height: 60px !important;
            line-height: normal !important;
        }
        /deep/ .ceil {
            display: flex;
            width: 100% !important;
            /deep/ .left {
                flex: 1;
                width: 30%;
                height: 100%;
            }
            /deep/ .right {
                flex: 1;
                height: 100%;
                text-align: center;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/dataBoard/lineChart.vue